import { TOrder } from "../@types";

export const getOrderString = (order: TOrder): string =>
  order.map((entry) => `${entry.key}:${entry.value}`).join(",");

export const setStringToOrder = (entry: string) => {
  const [key, value] = entry.split(":", 2);
  return { [key]: value };
};
